import alertColor from './alert_color.png';
import back from './back.png';
import close from './close.png';
import closeContrast from './close_contrast.png';
import doneContrast from './done_contrast.png';
import email from './email.png';
import error from './error.png';
import errorOutline from './error_outline.png';
import facebook from './facebook.png';
import google from './google.png';
import left from './left.png';
import linkedin from './linkedin.png';
import navArrow from './nav-arrow.png';
import right from './right.png';
import search from './search.png';
import shareContrast from './share_contrast.png';
import twitter from './twitter.png';

export default {
  alertColor,
  back,
  close,
  closeContrast,
  doneContrast,
  email,
  error,
  errorOutline,
  facebook,
  google,
  left,
  linkedin,
  navArrow,
  right,
  search,
  shareContrast,
  twitter,
};
